var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-collapse", {
    model: {
      value: _vm.activeKey,
      callback: function ($$v) {
        _vm.activeKey = $$v;
      },
      expression: "activeKey"
    }
  }, _vm._l(_vm.list, function (item, index) {
    return _c("a-collapse-panel", {
      key: String(item.id),
      attrs: {
        header: item.id == -1 ? _vm.$t("第") + Number(index + 1) + _vm.$t("节点流设置") : _vm.$t("第") + Number(index + 1) + _vm.$t("节点流设置") + "(" + _vm.$t(item.name) + ")"
      }
    }, [_c("node-item", {
      attrs: {
        num: index + 1,
        dataFrom2: item,
        process: _vm.processList,
        maxNodeNum: _vm.list.length,
        itemid: _vm.id,
        bankData: _vm.bankData,
        countriesData: _vm.countriesData,
        logisticsData: _vm.logisticsData,
        provinceArea: _vm.provinceArea,
        provinceData: _vm.provinceData,
        provinceFirstLevel: _vm.provinceFirstLevel,
        isEdit: item.isEdit
      },
      on: {
        editOk: _vm.editFun,
        ok: _vm.getInfoFun,
        cancel: _vm.cancelFun
      }
    })], 1);
  }), 1), _c("a-button", {
    staticClass: "marginT20",
    attrs: {
      type: "dashed",
      disabled: _vm.addButtonDisabled
    },
    on: {
      click: _vm.addNodeFun
    }
  }, [_vm._v(_vm._s(_vm.$t("新增节点")))]), _c("div", {
    staticClass: "marginT20"
  }, [_c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "primary"
    },
    on: {
      click: function ($event) {
        return _vm.$emit("Back");
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("上一步")))]), _c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.nextFun
    }
  }, [_vm._v(_vm._s(_vm.$t("下一步")))])], 1), _c("a-modal", {
    attrs: {
      visible: _vm.previewVisible,
      footer: null,
      title: _vm.$t("提示")
    },
    on: {
      cancel: function ($event) {
        _vm.previewVisible = false;
      }
    }
  }, _vm._l(_vm.specifyNodeInfo, function (item, index) {
    return _c("p", {
      key: index
    }, [_vm._v(_vm._s(item))]);
  }), 0)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };